<template>
  <span class = "label label-danger pull-right notice" v-show = "count > 0">{{ count }}</span>
</template>
<script>
  export default {
    name: 'comp-notification',
    props: ['channel', 'userId', 'soundEffect'],
    data () {
      return {
        count: 0
      }
    },
    mounted () {
      const channel = pusher.subscribe('personal.' + this.userId)
      channel.bind(this.channel, (message) => {
        const loop = _.get(message, 'loop', 0)
        // console.log(loop)
        let sound = soundSmoke
        if (message.sound) {
          if (this.soundEffect) {
            sound = this.soundEffect
          }
          createjs.Sound.play(sound, { interrupt: createjs.Sound.INTERRUPT_ANY, loop: loop });
        }
        this.count = message.data
      })

      // Request default.
      // This is make 1 query user request.
      axios.get('/notification/' + this.channel)
        .then(resp => {
          this.count = resp.data.count
        })
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/Notification.vue